import { Link } from "react-router-dom";

import React, { Component } from "react";
import { createVehicle, createInspection } from "../../graphql/mutations";
import withStyles from "@material-ui/core/styles/withStyles";
import { listVehicleTypes, listVehicles } from "../../graphql/queries";
import gql from "graphql-tag";
import uuid from "uuid";
import { API, graphqlOperation, Storage } from "aws-amplify";
import Select from "react-select";
import * as actionTypes from "../../redux/actions";
import { styles } from "../../assets/css/styles.js";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import {
  Button,
  FormGroup,
  Form,
  Input,
  InputGroup,
  Container,
  Row,
  Col,
  Label
} from "reactstrap";
// import { onCreateInspection } from "../../graphql/subscriptions";

import { connect } from "react-redux";
import { toast } from "react-toastify";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import { spinnerService } from "@chevtek/react-spinners";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import _ from "lodash";
var self = null;
let today = new Date();
let month =
  today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1;
let date = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
let mainImage = null,
  vinPic = null,
  licensePic = null;
let currentDate = `${today.getFullYear()}-${month}-${date}`;
class AddVehicle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeName: "",
      _typeName: {
        value: "",
        isValid: true,
        err: ""
      },
      createdAt: "",
      customerVehicleId: "",
      _customerVehicleId: {
        value: "",
        isValid: true,
        err: ""
      },
      Id: "",
      license: "",
      _license: {
        value: "",
        isValid: true,
        err: ""
      },
      locationLat: "",
      locationLong: "",
      make: "",
      _make: {
        value: "",
        isValid: true,
        err: ""
      },
      model: "",
      _model: {
        value: "",
        isValid: true,
        err: ""
      },
      updatedAt: "",
      vehicleCustomerId: "",
      vehicleYear: "",
      _vehicleYear: {
        value: "",
        isValid: true,
        err: ""
      },
      vIN: "",
      _vIN: {
        value: "",
        isValid: true,
        err: ""
      },
      selectedOptions: [],
      specialInstructions: "",
      notes: "",
      bitDueDate45: null,
      _bitDueDate45: {
        value: "",
        isValid: true,
        err: ""
      },
      bitDueDate90: null,
      _bitDueDate90: {
        value: "",
        isValid: true,
        err: ""
      },
      dotDueDate: null,
      _dotDueDate: {
        value: "",
        isValid: true,
        err: ""
      },
      files: [],
      uploadedFiles: [],
      registeredInspectionType:
        this.props.location.state !== undefined
          ? this.props.location.state.registeredInspectionType
          : "",
      vehicleImage: {},
      vinImage: {},
      licenseImage: {},
      deactivateBIT: false,
      deactivateDOT: false
    };
  }
  notify = msg => toast(msg);
  addVehicle = async e => {
    let {
      typeName,
      createdAt,
      customerVehicleId,
      Id,
      license,
      make,
      model,
      bitDueDate45,
      bitDueDate90,
      dotDueDate,
      vehicleYear,
      vIN,
      registeredInspectionType,
      specialInstructions,
      deactivateBIT,
      deactivateDOT,
      _typeName,
      _vehicleYear,
      _make,
      _model,
      _license,
      _customerVehicleId,
      _bitDueDate45,
      _bitDueDate90,
      _dotDueDate,
      _vIN
    } = this.state;
    let {} = this.state;
    const { profile } = this.props;
    e.preventDefault();
    let errorCheck = false;
    if (
      _customerVehicleId.value === "" ||
      _customerVehicleId.value === null ||
      _customerVehicleId.value === undefined
    ) {
      this.submitCheck("_customerVehicleId", _customerVehicleId.value);
      document.getElementById("_customerVehicleId").focus();
      return;
    }
    if (
      _typeName.value === "" ||
      _typeName.value === null ||
      _typeName.value === undefined
    ) {
      this.submitCheck("_typeName", _typeName.value);
      document.getElementById("typeName").focus();
      return;
    }
    if (_vIN.value === "" || _vIN.value === null || _vIN.value === undefined) {
      this.submitCheck("_vIN", _vIN.value);
      document.getElementById("_vIN").focus();
      return;
    }
    if (registeredInspectionType === "FEDERAL") {
      if (
        (_dotDueDate.value === "" ||
          _dotDueDate.value === null ||
          _dotDueDate.value === undefined) &&
        // !this.state.deactivateDOT
        true
      ) {
        this.submitCheck("_dotDueDate", _dotDueDate.value);
        document.getElementById("_dotDueDate").focus();
        return;
      }
    } else if (registeredInspectionType === "BIT") {
      if (
        (_bitDueDate90.value === "" ||
          _bitDueDate90.value === null ||
          _bitDueDate90.value === undefined) &&
        !this.state.deactivateBIT
      ) {
        this.submitCheck("_bitDueDate90", _bitDueDate90.value);
        document.getElementById("_bitDueDate90").focus();
        return;
      }
    } else if (registeredInspectionType === "FEDERAL_BIT") {
      if (
        (_bitDueDate90.value === "" ||
          _bitDueDate90.value === null ||
          _bitDueDate90.value === undefined) &&
        !this.state.deactivateBIT
      ) {
        this.submitCheck("_bitDueDate90", _bitDueDate90.value);
        document.getElementById("_bitDueDate90").focus();
        return;
      }
      if (
        (_dotDueDate.value === "" ||
          _dotDueDate.value === null ||
          _dotDueDate.value === undefined) &&
        !this.state.deactivateDOT
      ) {
        this.submitCheck("_dotDueDate", _dotDueDate.value);
        document.getElementById("_dotDueDate").focus();
        return;
      }
    } else if (registeredInspectionType === "BUS_LIMOS") {
      if (
        (_bitDueDate45.value === "" ||
          _bitDueDate45.value === null ||
          _bitDueDate45.value === undefined) &&
        !this.state.deactivateBIT
      ) {
        this.submitCheck("_bitDueDate45", _bitDueDate45.value);
        document.getElementById("_bitDueDate45").focus();
        return;
      }
    }
    if (!new RegExp("[A-HJ-NPR-Z0-9]{17}").test(_vIN.value)) {
      document.getElementById("_vIN").focus();
      spinnerService.hide("mySpinner");
      toast.error("Please insert Valid VIN.");
      return;
    }
    // if (errorCheck) {
    //   toast.error("Fields marked with * can not be left blank.");
    //   return;
    // }
    if (!new RegExp("[A-HJ-NPR-Z0-9]{17}").test(_vIN.value)) {
      document.getElementById("_vIN").focus();
      this.setState({
        _vIN: {
          value: _vIN.value,
          isValid: false,
          err: "VIN is not in correct format."
        }
      });
      toast.error("VIN is not in correct format.");
      return;
    }
    let customer = profile; //JSON.parse(localStorage.getItem("cust"));
    if (customer) {
      try {
        //const uuidv4 = require("uuid/v4");
        (make = _make.value),
          (customerVehicleId = _customerVehicleId.value),
          (model = _model.value),
          (license = _license.value),
          (vehicleYear = _vehicleYear.value),
          (bitDueDate90 = _bitDueDate90.value),
          (bitDueDate45 = _bitDueDate45.value),
          (dotDueDate = _dotDueDate.value),
          (typeName = _typeName.value),
          (vIN = _vIN.value);
        this.setState({
          make: _make.value,
          customerVehicleId: _customerVehicleId.value,
          model: _model.value,
          license: _license.value,
          vehicleYear: _vehicleYear.value,
          bitDueDate90: _bitDueDate90.value,
          bitDueDate45: _bitDueDate45.value,
          dotDueDate: _dotDueDate.value,
          typeName: _typeName.value,
          vIN: _vIN.value
        });
        const returnData = await this.props.client.query({
          // query: gql(getCustomer),
          query: gql(listVehicles),
          fetchPolicy: `network-only`,
          variables: {
            filter: {
              customerVehicleId: { eq: _customerVehicleId.value }
            }
          }
        });
        if (returnData.data.listVehicles.items.length > 0) {
          toast.error(`Vehicle ${_customerVehicleId.value} already exists`);
          return;
        }
        var input = {
          id: vIN, //uuidv4(),
          customerVehicleId: customerVehicleId,
          locationLat: customer.customerAddresses[0].locationLat,
          locationLong: customer.customerAddresses[0].locationLong,
          vehicleCustomerId: customer.id,
          vehicleVehicleTypeId: typeName.value,
          vehicleStatus: "INSERVICE"
        };
        if (customer.customerAddresses.length > 0) {
          input.locationLat = customer.customerAddresses[0].locationLat;
          input.locationLong = customer.customerAddresses[0].locationLong;
        }
        if (deactivateBIT === true) input.deactivateBIT = true;
        else input.deactivateBIT = false;
        if (deactivateDOT === true) input.deactivateDOT = true;
        else input.deactivateDOT = false;
        if (make !== "") input.make = make;
        if (vIN !== "") input.VIN = vIN;
        if (model !== "") input.model = model;
        if (specialInstructions !== "")
          input.specialInstructions = specialInstructions;
        if (license !== "") input.license = license;
        if (vehicleYear !== "") input.vehicleYear = vehicleYear;

        /*
          let regInspectionCats = [];
          if ((bitDueDate45 !== "") | (bitDueDate90 !== "")) {
            regInspectionCats.push("BIT");
            if (bitDueDate90 !== "") {
              nextInspDueArray.push({
                inspectionType: "BIT_90DAY_INSPECTION",
                nextDueDate: bitDueDate90
              });
            }
            if (bitDueDate45 !== "") {
              nextInspDueArray.push({
                inspectionType: "BIT_45DAY_INSPECTION",
                nextDueDate: bitDueDate45
              });
            }
          }
          if (dotDueDate !== "") {
            regInspectionCats.push("DOT");
            nextInspDueArray.push({
              inspectionType: "DOT_ANNUAL_INSPECTION",
              nextDueDate: dotDueDate
            });
          }
          if (regInspectionCats.length > 0) {
            input.registeredInspectionCats = regInspectionCats;
          }
          */

        // Disabled as per client request. code functional for obtaining inspection dates
        let nextInspDueArray = [];
        if (registeredInspectionType === "FEDERAL" && !deactivateDOT) {
          nextInspDueArray.push({
            inspectionType: "DOT_ANNUAL_INSPECTION",
            nextDueDate: dotDueDate
          });
        } else if (registeredInspectionType === "BIT" && !deactivateBIT) {
          nextInspDueArray.push({
            inspectionType: "BIT_90DAY_INSPECTION",
            nextDueDate: bitDueDate90
          });
        } else if (registeredInspectionType === "FEDERAL_BIT") {
          if (!deactivateDOT) {
            nextInspDueArray.push({
              inspectionType: "DOT_ANNUAL_INSPECTION",
              nextDueDate: dotDueDate
            });
          }
          if (!deactivateBIT) {
            nextInspDueArray.push({
              inspectionType: "BIT_90DAY_INSPECTION",
              nextDueDate: bitDueDate90
            });
          }
        } else if (registeredInspectionType === "BUS_LIMOS" && !deactivateBIT) {
          nextInspDueArray.push({
            inspectionType: "BIT_45DAY_INSPECTION",
            nextDueDate: bitDueDate45
          });
        }

        if (nextInspDueArray.length > 0) {
          input.nextInspectionDue = nextInspDueArray;
        } else {
          input.nextInspectionDue = [];
        }

        spinnerService.show("mySpinner");
        await this.uploadImages();
        let {
          uploadedFiles,
          licenseImage,
          vinImage,
          vehicleImage
        } = this.state;
        input.vehicleUploads = uploadedFiles;
        input.vinPic = vinPic;
        input.licensePic = licensePic;
        input.mainPic = mainImage;
        var result = await API.graphql(
          graphqlOperation(createVehicle, { input })
        );

        spinnerService.hide("mySpinner");
        //Refresh the state
        this.setState({
          vIN: "",
          customerVehicleId: "",
          make: "",
          model: "",
          specialInstructions: "",
          license: "",
          vehicleYear: "",
          typeName: "",
          Id: "",
          bitDueDate: "",
          uploadedFiles: [],
          files: [],
          vinImage: "",
          licenseImage: "",
          vehicleImage: ""
        });

        vinPic = null;
        licensePic = null;
        mainImage = null;

        let vehObj = [
          input.id,
          input.customerVehicleId,
          input.make,
          input.model,
          input.VIN,
          "Details",
          "Edit",
          "Del"
        ];
        this.props.addVehicle(vehObj);
        toast.success("Vehicle Added");
        this.props.history.push("/company", {
          reload: true
        });
      } catch (e) {
        spinnerService.hide("mySpinner");

        e.errors.map(err => {
          if (err.errorType === "DynamoDB:ConditionalCheckFailedException")
            toast.error(
              "Duplicate VIN entry. This VIN already exists in our records."
            );
        });
      }
    } else {
      toast.error("User credentials not found");
    }
  };
  handleSubmit = e => {
    this.addVehicle(e);
  };

  cancelForm = e => {
    this.props.history.push("/company");
  };
  loadVehTypes = async () => {
    const { client } = this.props;

    const vehTypesList = await client.query({
      query: gql(listVehicleTypes),
      fetchPolicy: `network-only`
    });

    const vehTypesArray = new Array();
    if (
      vehTypesList.data.listVehicleTypes !== null &&
      vehTypesList.data.listVehicleTypes.items !== undefined
    ) {
      vehTypesList.data.listVehicleTypes.items.map(itm => {
        let vehType = {};
        vehType.value = itm.id;
        vehType.label = itm.vehicleType;
        vehTypesArray.push(vehType);
      });
    }
    this.setState({ selectedOptions: vehTypesArray }); //=vehTypesArray.slice();
  };
  async componentDidMount() {
    const { profile } = this.props;
    const { registeredInspectionType } = this.props.location.state;
    if (![null, undefined].includes(this.props.location.state)) {
      this.setState({
        registeredInspectionType
      });
    }
    await this.loadVehTypes();
  }
  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  _onInputChange = event => {
    const { id, value } = event.target;
    if (id === "_vIN") {
      this.setState({
        [id]: {
          value: value.toUpperCase(),
          isValid: true,
          err: ""
        }
      });
    } else
      this.setState({
        [id]: {
          value,
          isValid: true,
          err: ""
        }
      });
  };

  submitCheck = (id, value) => {
    let arr = ["_vIN", "typeName", "_vehicleYear", "_customerVehicleId"];
    let arr1 = ["_dotDueDate", "_bitDueDate90", "_bitDueDate45"];
    if (
      (value === "" || value === null || value === undefined) &&
      arr1.includes(id)
    ) {
      if (id === "_dotDueDate" && !this.state.deactivateDOT) {
        this.setState({
          _dotDueDate: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
      if (id === "_bitDueDate90" && !this.state.deactivateBIT) {
        this.setState({
          _bitDueDate90: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
      if (id === "_bitDueDate45" && !this.state.deactivateBIT) {
        this.setState({
          _bitDueDate45: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
    }
    if (
      (value === "" || value === null || value === undefined) &&
      !arr1.includes(id)
    ) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "This Field is Required"
        }
      });
    } else if (value.length > 0) {
      if (!arr.includes(id) && !arr1.includes(id) && value.length < 4) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 4 Characters Are Reuired"
          }
        });
      } else if (id === "_vIN" && value.length < 17) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "VIN Must be 17 Characters Long"
          }
        });
      }
    }
    if (id === "react-select-2-input") {
      if (this.state.typeName === null || this.state.typeName === "") {
        this.setState({
          _typeName: {
            value: this.state.typeName,
            isValid: false,
            err: "Please Select A Vehicle Type"
          }
        });
      }
    }
  };
  runtimeCheck = event => {
    const { id, value } = event.target;
    let arr = ["_vIN", "typeName", "_vehicleYear", "_customerVehicleId"];
    let arr1 = ["_dotDueDate", "_bitDueDate90", "_bitDueDate45"];
    if (
      (value === "" || value === null || value === undefined) &&
      arr1.includes(id)
    ) {
      if (id === "_dotDueDate" && !this.state.deactivateDOT) {
        this.setState({
          _dotDueDate: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
      if (id === "_bitDueDate90" && !this.state.deactivateBIT) {
        this.setState({
          _bitDueDate90: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
      if (id === "_bitDueDate45" && !this.state.deactivateBIT) {
        this.setState({
          _bitDueDate45: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
    }
    if (
      (value === "" || value === null || value === undefined) &&
      !arr1.includes(id)
    ) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "This Field is Required"
        }
      });
    } else if (value.length > 0) {
      if (!arr.includes(id) && !arr1.includes(id) && value.length < 4) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 4 Characters Are Reuired"
          }
        });
      } else if (id === "_vIN" && value.length < 17) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "VIN Must be 17 Characters Long"
          }
        });
      }
    }
    if (id === "react-select-2-input") {
      if (this.state.typeName === null || this.state.typeName === "") {
        this.setState({
          _typeName: {
            value: this.state.typeName,
            isValid: false,
            err: "Please Select A Vehicle Type"
          }
        });
      }
    }
  };
  onInputVINChange = event => {
    let val = event.target.value.toUpperCase();
    this.setState({
      [event.target.id]: val
    });
  };
  onBlurVIN = event => {
    let vin = this.state.vIN;
    if (vin.length < 17) return;
  };
  handleChange = typeName => {
    this.setState({
      typeName,
      _typeName: {
        value: typeName,
        isValid: true,
        err: ""
      }
    });
    //
  };
  fileSelect = e => {
    let file = e.target.files[0];
    let { files } = this.state;
    files.push(file);
    this.setState({ files }, () => {});
    // let url=URL.createObjectURL(file);
  };
  removeFile = item => {
    let { files } = this.state;
    files.splice(files.indexOf(item), 1);
    this.setState({ files });
  };
  uploadImages = async () => {
    const {
      files,
      uploadedFiles,
      vehicleImage,
      vinImage,
      licenseImage
    } = this.state;
    if (vehicleImage.name) {
      let key = await Storage.put(
        new Date().getTime() + vehicleImage.name,
        vehicleImage
      );
      mainImage = {
        bucket: "calbitwebappuploadbucket1254-dev",
        region: "us-east-2",
        key: key.key
      };
    }
    if (vinImage.name) {
      let key = await Storage.put(
        new Date().getTime() + vinImage.name,
        vinImage
      );
      vinPic = {
        bucket: "calbitwebappuploadbucket1254-dev",
        region: "us-east-2",
        key: key.key
      };
    }
    if (licenseImage.name) {
      let key = await Storage.put(
        new Date().getTime() + licenseImage.name,
        licenseImage
      );
      licensePic = {
        bucket: "calbitwebappuploadbucket1254-dev",
        region: "us-east-2",
        key: key.key
      };
    }
    if (files.length === 0) {
      return;
    }
    await Promise.all(
      files.length !== 0 &&
        files.map(async (item, index) => {
          if (item.file === null) {
            uploadedFiles.push({
              title: item.title,
              dateAchieved: currentDate,
              attachment: null
            });
          } else {
            try {
              let key = await Storage.put(
                new Date().getTime() + item.name,
                item
              );
              uploadedFiles.push({
                bucket: "calbitwebappuploadbucket1254-dev",
                region: "us-east-2",
                key: key.key
              });
              this.setState({ uploadedFiles });
            } catch (err) {}
          }
        })
    );
  };
  handleVehicleImage = e => {
    let file = e.target.files[0];
    let { vehicleImage } = this.state;
    vehicleImage = file;
    this.setState({ vehicleImage });
  };
  handleVinImage = e => {
    let file = e.target.files[0];
    let { vinImage } = this.state;
    vinImage = file;
    this.setState({ vinImage });
  };

  handleLicenseImage = e => {
    let file = e.target.files[0];
    let { licenseImage } = this.state;
    licenseImage = file;
    this.setState({ licenseImage });
  };

  _onFocus = e => {
    e.currentTarget.type = "date";
  };
  _onBlur = (e, msg) => {
    e.currentTarget.type = "text";
    e.currentTarget.placeholder = msg;
  };
  render() {
    const {
      selectedOptions,
      files,
      registeredInspectionType,
      vehicleImage,
      vinImage,
      licenseImage
    } = this.state;
    const { classes } = this.props;

    let inspectionDatesUI = <div></div>;
    if (registeredInspectionType === "FEDERAL") {
      inspectionDatesUI = (
        <Row form>
          <Col>
            <FormGroup>
              <Label for="name">DOT Due Date *</Label>
              <InputGroup className="input-group-alternative mb-3">
                <Input
                  id="_dotDueDate"
                  type="date"
                  onChange={this._onInputChange}
                  disabled={this.state.deactivateDOT}
                  onBlur={!this.state.deactivateDOT && this.runtimeCheck}
                  placeholder="DOT Due Date"
                  value={this.state._dotDueDate.value}
                  required
                />
              </InputGroup>
              {/* <div style={{ fontSize: "smaller", marginTop: -15 }}>
                Your selected Inspection type is "Federal". If you want to
                change please go to Company Setup link.
              </div> */}
              {!this.state._dotDueDate.isValid && (
                <text
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 10
                  }}
                >
                  {" "}
                  {this.state._dotDueDate.err}
                </text>
              )}
            </FormGroup>
          </Col>
        </Row>
      );
    } else if (registeredInspectionType === "BIT") {
      inspectionDatesUI = (
        <Row form>
          <Col>
            <FormGroup>
              <Label for="name">BIT Due Date</Label>
              <InputGroup className="input-group-alternative mb-3">
                <Input
                  id="_bitDueDate90"
                  type="date"
                  onChange={this._onInputChange}
                  disabled={this.state.deactivateBIT}
                  onBlur={!this.state.deactivateBIT && this.runtimeCheck}
                  placeholder="BIT (90 Day) Due Date"
                  value={this.state._bitDueDate90.value}
                  required
                />
              </InputGroup>
              {!this.state._bitDueDate90.isValid && (
                <text
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 10
                  }}
                >
                  {" "}
                  {this.state._bitDueDate90.err}
                </text>
              )}
            </FormGroup>
          </Col>
        </Row>
      );
    } else if (registeredInspectionType === "FEDERAL_BIT") {
      inspectionDatesUI = (
        <Row form>
          <Col>
            <FormGroup>
              <Label for="name">DOT Due Date</Label>
              <InputGroup className="input-group-alternative mb-3">
                <Input
                  id="_dotDueDate"
                  type="date"
                  onChange={this._onInputChange}
                  disabled={this.state.deactivateDOT}
                  onBlur={!this.state.deactivateDOT && this.runtimeCheck}
                  placeholder="DOT Due Date"
                  value={this.state._dotDueDate.value}
                  required
                />
              </InputGroup>
              {!this.state._dotDueDate.isValid && (
                <text
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 10
                  }}
                >
                  {" "}
                  {this.state._dotDueDate.err}
                </text>
              )}
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label for="name">BIT Due Date</Label>
              <InputGroup className="input-group-alternative mb-3">
                <Input
                  id="_bitDueDate90"
                  type="date"
                  onChange={this._onInputChange}
                  disabled={this.state.deactivateBIT}
                  onBlur={!this.state.deactivateBIT && this.runtimeCheck}
                  placeholder="BIT (90 Day) Due Date"
                  value={this.state._bitDueDate90.value}
                  required
                />
              </InputGroup>
              {/* <div style={{ fontSize: "smaller", marginTop: -15 }}></div> */}
              {!this.state._bitDueDate90.isValid && (
                <text
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 10
                  }}
                >
                  {" "}
                  {this.state._bitDueDate90.err}
                </text>
              )}
            </FormGroup>
          </Col>
        </Row>
      );
    } else if (registeredInspectionType === "BUS_LIMOS") {
      inspectionDatesUI = (
        <Row form>
          <Col>
            <FormGroup>
              <Label for="name">BIT 45Days Due Date</Label>
              <InputGroup className="input-group-alternative mb-3">
                <Input
                  style={{ marginLeft: 5 }}
                  id="_bitDueDate45"
                  type="text"
                  disabled={this.state.deactivateBIT}
                  onChange={this._onInputChange}
                  onBlur={this.runtimeCheck}
                  placeholder="BIT (45 Day) Due Date"
                  value={this.state._bitDueDate45.value}
                  required
                />
              </InputGroup>
              {!this.state._bitDueDate45.isValid && (
                <text
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 10
                  }}
                >
                  {" "}
                  {this.state._bitDueDate45.err}
                </text>
              )}
            </FormGroup>
          </Col>
        </Row>
      );
    }

    return (
      <div>
        <main ref="main" App>
          <section className="section section-shaped section-lg">
            <Container className="pt-lg-sm pt-2">
              <Row className="justify-content-center">
                <Col lg={10}>
                  <Card>
                    <CardHeader className={classes.cardHeader}>
                      <h4 className={classes.cardTitleWhite}>Add Vehicle </h4>
                      <p className={classes.cardCategoryWhite}>Enter Details</p>
                    </CardHeader>
                    <CardBody>
                      <Form onSubmit={this.handleSubmit} role="form">
                        <Row form>
                          <Col md={12}>
                            <FormGroup>
                              <Label for="name">Vehicle Name/Id</Label>
                              <span style={{ margin: 10, cursor: "pointer" }}>
                                (
                                {!vehicleImage.name && (
                                  <div
                                    className="upload-btn-wrapper"
                                    style={{
                                      marginBottom: -8,
                                      cursor: "pointer"
                                    }}
                                  >
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        color: "blue",
                                        textDecoration: "underline"
                                      }}
                                    >
                                      Add Vehicle Image
                                    </span>
                                    <input
                                      id="def-pic"
                                      type="file"
                                      name="myfile"
                                      onChange={e => this.handleVehicleImage(e)}
                                    />
                                  </div>
                                )}
                                {vehicleImage.name && (
                                  <span>
                                    <span
                                      className="badge badge-pill badge-primary"
                                      style={{ fontSize: 16 }}
                                    >
                                      {vehicleImage.name}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({ vehicleImage: {} })
                                        }
                                      >
                                        {" "}
                                        x
                                      </span>
                                    </span>
                                  </span>
                                )}
                                )
                              </span>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  autoFocus
                                  id="_customerVehicleId"
                                  // onChange={this.onInputChange}
                                  onChange={this._onInputChange}
                                  onBlur={this.runtimeCheck}
                                  placeholder="Vehicle ID"
                                  type="text"
                                  value={this.state._customerVehicleId.value}
                                  required
                                />
                              </InputGroup>
                              {!this.state._customerVehicleId.isValid && (
                                <text
                                  style={{
                                    color: "red",
                                    fontSize: 12,
                                    marginLeft: 10
                                  }}
                                >
                                  {" "}
                                  {this.state._customerVehicleId.err}
                                </text>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="typeName">Vehicle Type</Label>
                              <Select
                                required
                                value={this.state.typeName}
                                onChange={this.handleChange}
                                onBlur={this.runtimeCheck}
                                id="typeName"
                                placeholder="Vehicle Type"
                                options={selectedOptions}
                              />
                              {!this.state._typeName.isValid && (
                                <text
                                  style={{
                                    color: "red",
                                    fontSize: 12,
                                    marginLeft: 10
                                  }}
                                >
                                  {" "}
                                  {this.state._typeName.err}
                                </text>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="vIn">VIN </Label>
                              <span style={{ margin: 10 }}>
                                (
                                {!vinImage.name && (
                                  <span
                                    className="upload-btn-wrapper"
                                    style={{ marginBottom: -8 }}
                                  >
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        color: "blue",
                                        textDecoration: "underline"
                                      }}
                                    >
                                      Add VIN Image
                                    </span>
                                    <input
                                      id="def-pic"
                                      type="file"
                                      name="myfile"
                                      onChange={e => this.handleVinImage(e)}
                                    />
                                  </span>
                                )}
                                {vinImage.name && (
                                  <span>
                                    <span
                                      className="badge badge-pill badge-primary"
                                      style={{ fontSize: 16 }}
                                    >
                                      {vinImage.name}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({ vinImage: {} })
                                        }
                                      >
                                        {" "}
                                        X
                                      </span>
                                    </span>
                                  </span>
                                )}
                                )
                              </span>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="_vIN"
                                  onChange={this._onInputChange}
                                  placeholder="V I N (17 Characters Long)"
                                  type="text"
                                  maxlength="17"
                                  minlength="17"
                                  onBlur={this.runtimeCheck}
                                  value={this.state._vIN.value}
                                  required
                                />
                              </InputGroup>
                              {!this.state._vIN.isValid && (
                                <text
                                  style={{
                                    color: "red",
                                    fontSize: 12,
                                    marginLeft: 10
                                  }}
                                >
                                  {" "}
                                  {this.state._vIN.err}
                                </text>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="name">Vehicle Year</Label>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  required
                                  id="_vehicleYear"
                                  placeholder="Vehicle Year"
                                  type="text"
                                  onChange={this._onInputChange}
                                  value={this.state._vehicleYear.value}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="name">License</Label>
                              <span
                                style={{ marginBottom: 10, marginLeft: 10 }}
                              >
                                (
                                {!licenseImage.name && (
                                  <span
                                    className="upload-btn-wrapper"
                                    style={{ marginBottom: -8 }}
                                  >
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        color: "blue",
                                        textDecoration: "underline"
                                      }}
                                    >
                                      Add License Image
                                    </span>
                                    <input
                                      id="def-pic"
                                      type="file"
                                      name="myfile"
                                      onChange={e => this.handleLicenseImage(e)}
                                    />
                                  </span>
                                )}
                                {licenseImage.name && (
                                  <span style={{ marginBottom: -8 }}>
                                    <span
                                      className="badge badge-pill badge-primary"
                                      style={{ fontSize: 16 }}
                                    >
                                      {licenseImage.name}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({ licenseImage: {} })
                                        }
                                      >
                                        {" "}
                                        X
                                      </span>
                                    </span>
                                  </span>
                                )}
                                )
                              </span>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="_license"
                                  onChange={this._onInputChange}
                                  placeholder="License"
                                  type="text"
                                  value={this.state._license.value}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="name">Make</Label>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="_make"
                                  onChange={this._onInputChange}
                                  placeholder="Make"
                                  type="text"
                                  value={this.state._make.value}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="name">Model</Label>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  required
                                  id="_model"
                                  placeholder="Model"
                                  type="text"
                                  value={this.state._model.value}
                                  onChange={this._onInputChange}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row form>
                          <Col>
                            <FormGroup>
                              <Label for="name">Special Instructions</Label>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="specialInstructions"
                                  onChange={this.onInputChange}
                                  placeholder="Special Instructions"
                                  type="text"
                                  value={this.state.specialInstructions}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row style={{ display: "none" }} form>
                          <Col>
                            <FormGroup>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="notes"
                                  onChange={this.onInputChange}
                                  placeholder="Notes"
                                  type="text"
                                  value={this.state.notes}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        {inspectionDatesUI}
                        <Row>
                          <Col>
                            <div className="upload-btn-wrapper">
                              <button
                                className="btn"
                                onClick={e => e.preventDefault()}
                              >
                                Upload file(s)
                              </button>
                              <input
                                type="file"
                                name="myfile"
                                onChange={this.fileSelect}
                              />
                            </div>
                          </Col>
                          <Col>
                            {" "}
                            {registeredInspectionType !== "FEDERAL" && (
                              <div style={{ float: "right" }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.deactivateBIT}
                                      onChange={e =>
                                        this.setState({
                                          deactivateBIT: e.target.checked,
                                          _bitDueDate90: {
                                            value: this.state._bitDueDate90
                                              .value,
                                            isValid: true,
                                            err: ""
                                          }
                                        })
                                      }
                                      inputProps={{
                                        "aria-label": "primary checkbox"
                                      }}
                                    />
                                  }
                                  label="Disable BIT"
                                />
                              </div>
                            )}
                            {registeredInspectionType !== "BIT" && (
                              <div
                                style={{ float: "right", marginRight: "2px" }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.deactivateDOT}
                                      onChange={e =>
                                        this.setState({
                                          deactivateDOT: e.target.checked,
                                          _dotDueDate: {
                                            value: this.state._dotDueDate.value,
                                            isValid: true,
                                            err: ""
                                          }
                                        })
                                      }
                                      inputProps={{
                                        "aria-label": "primary checkbox"
                                      }}
                                    />
                                  }
                                  label="Disable DOT"
                                />
                              </div>
                            )}
                          </Col>
                        </Row>

                        <Row>
                          {files.map((item, i) => {
                            return (
                              <span
                                key={i}
                                style={{ fontSize: 16, margin: 10 }}
                                className="badge badge-pill badge-primary"
                              >
                                {item.name}
                                <span
                                  style={{ margin: 5, cursor: "pointer" }}
                                  onClick={() => this.removeFile(item)}
                                >
                                  X
                                </span>
                              </span>
                            );
                          })}
                        </Row>
                        <div className="text-center">
                          <Row lg="12" className="px-3 ">
                            <Col lg="2"></Col>
                            <Col>
                              <Button
                                className=" btn-lg btn-block mt-2"
                                color="default"
                                onClick={this.cancelForm}
                              >
                                Back
                              </Button>
                            </Col>{" "}
                            <Col>
                              <Button
                                className=" btn-lg btn-block mt-2"
                                color="primary"
                                type="submit"
                                onClick={this.handleSubmit}
                              >
                                Save
                              </Button>
                            </Col>
                            <Col lg="2"></Col>
                          </Row>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}

const classes = {
  blackButton: {
    "&,& a,& a:hover,& a:focus": {
      padding: "10px",
      color: "white",
      borderRadius: "5px",
      backgroundColor: "#000000"
    }
  }
};
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    loading: state.vehicles.loading,
    data: state.vehicles.data,
    profile: state.config.profile
  };
};
const mapDispatchToProps = dispatch => {
  return {
    addVehicle: data => dispatch(actionTypes.addVehicle(data))
  };
};
export default AddVehicle = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AddVehicle));



// WEBPACK FOOTER //
// ./src/views/Company/AddVehicle.js